import React from 'react'
import TopBar from './TopBar/TopBar'
import Header from './Header/Header'
import Form from './Form/Form'
import Footer from './Footer/Footer'
import Popup from './Popup/Popup'
import SelectPopup from './SelectPopup/SelectPopup'
import "../static/css/main.scss";
const App = () => {
    return (
        <div>
            <Popup/>
            <SelectPopup/>
            <TopBar/>
            <Header/>
            <Form/>
            <Footer/>
        </div>
    )
}

export default App
